import { useUrlProvider } from "../../useUrlProvider.ts";
import { DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { frameworkTemplateFilterKey } from "../../framework/frameworks/Frameworks.hooks.ts";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";

export interface MappedFrameworkViewModel {
    id: string;
    name: string;
    isPlanned: boolean;
    goToFrameworkOverview?: boolean;
}

export interface MappedFrameworkLinkProps {
    model: MappedFrameworkViewModel;
}

function MappedFrameworkLink(props: MappedFrameworkLinkProps) {
    const { model } = props;
    const urlProvider = useUrlProvider();
    const { permissions } = useUserContext();

    let link = model.goToFrameworkOverview ? urlProvider.getFrameworkOverviewUrl(model.id) : urlProvider.getFrameworksUrl();

    if (!model.goToFrameworkOverview) {
        if (model.isPlanned) {
            link = link + `?${frameworkTemplateFilterKey}=${model.id}`;
        } else {
            link = link + `#${model.id}`;
        }
    }

    return (
        <>
            {permissions.frameworkPermissions.read ? (
                <DotLegalLink bold to={link} linkColor={"primary"}>
                    {model.name}
                </DotLegalLink>
            ) : (
                model.name
            )}
        </>
    );
}

export default MappedFrameworkLink;
